module.exports = __webpack_public_path__ + "static/media/loader.e55702a4.webp";